// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

// Components
import RecommendationActionButton from './RecommendationActionButton';

class RecommendationFavoriteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false,
    };
  }

  getButtonText() {
    const { is_favorite } = this.props.recommendation;
    const { hovered } = this.state;

    if (is_favorite && hovered) {
      return 'Unfavourite';
    } else if (is_favorite) {
      return 'Favourited';
    } else {
      return 'Favourite';
    }
  }

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  favoriteRecommendation = () => {
    const { uuid, is_favorite } = this.props.recommendation;
    const payload = { is_favorite: !is_favorite };
    this.props.updateRecommendationStatus(uuid, payload);
  };

  render() {
    const buttonText = this.getButtonText();
    return (
      <RecommendationActionButton
        className={`RecommendationFavoriteButton ${buttonText}`}
        onClick={this.favoriteRecommendation}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {buttonText}
      </RecommendationActionButton>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateRecommendationStatus: actions.updateRecommendationStatus,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(
  RecommendationFavoriteButton
);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationFavoriteButton.js